/* eslint-disable no-unused-vars */
/* eslint-disable react/no-array-index-key */
import React, { Component } from 'react';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import {
  Container,
  Grid,
  Typography,
  Box,
  Button,
  Divider,
  Table,
  TableContainer,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  TextField,
  Stack,
} from '@mui/material';
import _ from 'lodash';
import { withSnackbar } from 'notistack';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Breadcrumbs } from 'wae_rwlb_reactlibrary';

import { removeItem, addToCart, clearCart, getCartData } from '../../actions/cart.actions';
import './styles.css';
import { COLOR } from '../../helpers/colors';
import { breadcrumbNameMap } from '../../helpers/config';
import { formatAmount, roundToTwoDecimals } from '../../helpers/functions';

class Cart extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  async componentDidMount() {
    try {
      await this.props.getCartData();
    } catch (err) {
      console.log(err);
    }
  }

  returnMaterialInfo = row => {
    const { Material, MaterialName, StockQuantity, StockQuantityUOM } = row;
    return (
      <>
        <Typography
          sx={{
            fontSize: { xs: 13, md: 14, lg: 16 },
            marginBottom: 0.75,
            paddingTop: 0.75,
            cursor: 'pointer',
            '&:hover': {
              color: COLOR.linkColor,
            },
          }}
        >
          {MaterialName}
        </Typography>
        <Typography sx={{ fontSize: { xs: 10, md: 12 }, marginBottom: 0.75 }}>
          {Material}
        </Typography>
        <Typography
          sx={{ fontSize: { xs: 12, md: 14 } }}
        >{`${StockQuantity} ${StockQuantityUOM}`}</Typography>
      </>
    );
  };

  renderCartItems = availableItems => {
    const { t } = this.props;
    const { cartItems } = this.props.cart;
    const outOfStockItems = _.filter(cartItems, c => !c.available);
    return (
      <Box sx={{ flexGrow: 1, marginTop: outOfStockItems.length > 0 ? 5 : 0 }}>
        <Typography sx={{ fontSize: { xs: 14, md: 18, lg: 24 }, mb: 2 }}>
          {t('cartScreenTranslations:CART_ITEMS')}
        </Typography>
        <TableContainer>
          <Table aria-label="simple table">
            <TableHead sx={{ borderTop: `1px solid ${COLOR.borderColor}` }}>
              <TableRow>
                {[
                  t('cartScreenTranslations:PRODUCT'),
                  t('cartScreenTranslations:QTY'),
                  t('cartScreenTranslations:PRICE'),
                  'Tax',
                  t('cartScreenTranslations:NET_VALUE'),
                ].map((h, index) => (
                  <TableCell
                    align="left"
                    sx={{
                      paddingY: 2,
                      paddingX: 1.5,
                      fontWeight: '600',
                      fontSize: { xs: 12, md: 14 },
                    }}
                    key={index.toString()}
                  >
                    {h}
                  </TableCell>
                ))}
                <TableCell align="center" sx={{ paddingY: 2, paddingX: 1.5 }}>
                  <Button
                    color="error"
                    variant="outlined"
                    onClick={() => this.props.clearCart()}
                    sx={{ fontSize: { xs: 12, md: 14 } }}
                  >
                    {t('cartScreenTranslations:CLEAR_CART')}
                  </Button>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {availableItems.map((row, index) => {
                const {
                  qty,
                  Material,
                  ConditionQuantity,
                  Price,
                  Currency,
                  available,
                  StockQuantity,
                  Tax,
                } = row;
                return (
                  <TableRow
                    key={index.toString()}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell
                      align="left"
                      sx={{ paddingY: 2, paddingX: 1.5 }}
                      // onClick={() => this.props.history.push(`/products/${Material}`)}
                    >
                      <Grid
                        container
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                      >
                        <img
                          src="/item_l.jpg"
                          alt=""
                          loading="lazy"
                          style={{ width: 110, height: 110 }}
                          // sx={{ display: { xs: 'none', md: 'block' } }}
                        />
                        <Grid item>{this.returnMaterialInfo(row)}</Grid>
                      </Grid>
                    </TableCell>
                    <TableCell align="left" sx={{ paddingY: 2, paddingX: 1.5 }}>
                      <Grid
                        container
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                        flexWrap="nowrap"
                      >
                        <Grid item>
                          <Button
                            variant="outlined"
                            color="inherit"
                            // className="secondary-btn"
                            sx={{ width: 44 }}
                            onClick={() => {
                              // if (qty - parseInt("ConditionQuantity", 10) === 0) {
                              if (qty - parseInt('1', 10) === 0) {
                                this.props.removeItem(Material);
                              } else {
                                this.props.addToCart({
                                  Material,
                                  // qty: -parseInt(ConditionQuantity, 10),
                                  qty: -parseInt('1', 10),
                                });
                              }
                            }}
                            disabled={!available}
                          >
                            -
                          </Button>
                        </Grid>
                        <Grid
                          item
                          sx={{
                            marginY: 1.25,
                          }}
                        >
                          <TextField
                            classes={{ root: 'custom-root-3' }}
                            sx={{ width: 64, paddingX: 0.75, fontSize: { xs: 12, md: 14 } }}
                            value={qty}
                            disabled={!available}
                          />
                        </Grid>

                        <Grid item>
                          <Button
                            variant="outlined"
                            color="inherit"
                            sx={{ width: 44 }}
                            onClick={() => {
                              if (qty < StockQuantity) {
                                this.props.addToCart({
                                  Material,
                                  // qty: parseInt(ConditionQuantity, 10),
                                  qty: parseInt('1', 10),
                                });
                              } else {
                                this.props.enqueueSnackbar(
                                  'Quantity reached available stock limit',
                                  {
                                    variant: 'warning',
                                  }
                                );
                              }
                            }}
                            disabled={!available}
                          >
                            +
                          </Button>
                        </Grid>
                      </Grid>
                    </TableCell>

                    <TableCell
                      // align="right"
                      sx={{
                        p: 1.5,
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: { sm: 12, md: 14, lg: 16 },
                        }}
                      >
                        {formatAmount('en-AE', Price, Currency)}
                      </Typography>
                    </TableCell>
                    <TableCell
                      // align="right"
                      sx={{
                        p: 1.5,
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: { sm: 12, md: 14, lg: 16 },
                        }}
                      >
                        {formatAmount('en-AE', Tax, Currency)}
                      </Typography>
                    </TableCell>
                    <TableCell
                      // align="right"
                      sx={{
                        p: 1.5,
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: { sm: 12, md: 14, lg: 16 },
                          // textAlign: 'left',
                        }}
                      >
                        {formatAmount(
                          'en-AE',
                          (roundToTwoDecimals(Price) + roundToTwoDecimals(Tax)) * qty,
                          Currency
                        )}
                      </Typography>
                    </TableCell>
                    <TableCell align="center" sx={{ paddingY: 2 }}>
                      <CloseOutlinedIcon
                        color="error"
                        sx={{ cursor: 'pointer' }}
                        fontSize="inherit"
                        onClick={() => this.props.removeItem(Material)}
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    );
  };

  onClickCheckout = () => {
    this.props.history.push({
      pathname: '/checkout',
      state: { isCheckout: true },
    });
  };

  onClickBackToShopping = () => this.props.history.push('/');

  renderOutOfStockItems = () => {
    const { cartItems } = this.props.cart;
    const outOfStockItems = _.filter(cartItems, c => !c.available);
    const { t } = this.props;
    return outOfStockItems.length > 0 ? (
      <Stack>
        <Typography sx={{ fontSize: { xs: 14, sm: 16, md: 24 }, marginTop: -2 }}>
          {t('cartScreenTranslations:OUT_OF_STOCK_ITEMS')}
        </Typography>
        {outOfStockItems.map((d, index) => {
          const { Material, qty } = d;
          return (
            <Grid key={index.toString()} sx={{ pt: 1, pb: 2 }}>
              <Divider />
              <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                sx={{ mt: 2, mb: 2 }}
              >
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  container
                  direction="row"
                  justifyContent={{ xs: 'center', md: 'flex-start' }}
                  alignItems="center"
                >
                  <Grid item xs={12} md={4} textAlign={{ xs: 'center', md: 'flex-start' }}>
                    <img
                      src="/item_l.jpg"
                      alt=""
                      loading="lazy"
                      style={{ width: 110, height: 110 }}
                      // sx={{ display: { xs: 'none', md: 'block' } }}
                    />
                  </Grid>

                  <Grid item xs={12} md={8} textAlign={{ xs: 'center', md: 'left' }}>
                    {this.returnMaterialInfo(d)}
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={4} md={4} textAlign="center" container direction="row">
                  <Typography sx={{ fontSize: { xs: 13, md: 16 } }}>
                    {`${t('cartScreenTranslations:QTY')} - ${qty}`}&nbsp;
                  </Typography>
                  <Typography sx={{ fontSize: { xs: 13, md: 16 }, color: COLOR.statusTextColor }}>
                    ( {t('cartScreenTranslations:OUT_OF_STOCK')} )
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={2} md={2} textAlign="center">
                  <CloseOutlinedIcon
                    color="error"
                    sx={{ cursor: 'pointer' }}
                    fontSize="inherit"
                    onClick={() => this.props.removeItem(Material)}
                  />
                </Grid>
              </Grid>
              <Divider />
            </Grid>
          );
        })}
      </Stack>
    ) : null;
  };

  returnTotalPrice = () => {
    let subTotal = 0;

    try {
      const { cart } = this.props;
      const { cartItems } = cart;

      const availableItems = _.filter(cartItems, c => c.available);
      availableItems.forEach(c => {
        subTotal += Number((roundToTwoDecimals(c.Price) + roundToTwoDecimals(c.Tax)) * c.qty);
      });
      return subTotal;
    } catch (err) {
      return subTotal;
    }
  };

  render() {
    const { cart, t } = this.props;
    const { cartItems } = cart;
    const availableItems = _.filter(cartItems, c => c.available);
    const isCartNotEmpty = availableItems.length > 0;
    const Currency = cartItems.length > 0 ? cartItems[0].Currency : '';
    return (
      <Container>
        <Breadcrumbs {...this.props} breadcrumbNameMap={breadcrumbNameMap(t)} />
        <Box sx={{ marginY: 3, pb: 5 }}>
          {this.renderOutOfStockItems()}
          {isCartNotEmpty ? (
            <>
              {this.renderCartItems(availableItems)}
              <Divider sx={{ mb: 2, mt: 2 }} />
              <Grid container>
                <Grid item xs={12} textAlign="end">
                  <Typography sx={{ fontSize: { xs: 10, sm: 14, md: 16 } }}>
                    <span style={{ color: COLOR.helperTextColor }}>
                      {t('cartScreenTranslations:TOTAL')}:&nbsp;
                    </span>
                    {formatAmount('en-AE', this.returnTotalPrice(), Currency)}
                  </Typography>
                </Grid>
              </Grid>
            </>
          ) : (
            <>
              <Grid container>
                <Grid item xs={12} textAlign="center">
                  <Typography
                    style={{
                      fontSize: 32,
                      color: COLOR.helperTextColor,
                      textAlign: 'center',
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                    }}
                  >
                    {t('cartScreenTranslations:CART_EMPTY')}
                  </Typography>
                </Grid>
              </Grid>
            </>
          )}
          <Divider sx={{ mb: 2, mt: 2 }} />
          <Grid container>
            <Grid item xs={6} textAlign="start">
              <Button
                variant="outlined"
                color="inherit"
                startIcon={<ArrowBackIcon />}
                onClick={this.onClickBackToShopping}
              >
                {t('cartScreenTranslations:BACK_TO_SHOPPING')}
              </Button>
            </Grid>
            <Grid item xs={6} textAlign="end">
              <Button
                variant="contained"
                color="primary"
                onClick={this.onClickCheckout}
                style={{ opacity: isCartNotEmpty ? 1 : 0.5 }}
                disabled={!isCartNotEmpty}
              >
                {t('cartScreenTranslations:CHECKOUT')}
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Container>
    );
  }
}

const mapStateToProps = state => {
  return {
    cart: state.cart,
    auth: state.auth,
  };
};
const cCart = connect(mapStateToProps, { removeItem, addToCart, clearCart, getCartData })(Cart);
const tCart = withTranslation(['cartScreenTranslations'])(cCart);
const sCart = withSnackbar(tCart);

export { sCart as Cart };
